import React from 'react';
import { LogOut, Menu } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import AIAlertBell from './AIAlertBell';

const Header = ({ onMenuClick }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await auth.signOut();
    navigate('/login');
  };

  return (
    <header className="w-full bg-[#0f172a] border-b border-gray-700 px-4 md:px-6 py-4 flex justify-between items-center text-white">
      {/* Botão do menu hambúrguer - só aparece no mobile */}
      <div className="flex items-center gap-4">
        <button
          className="md:hidden text-white"
          onClick={onMenuClick}
          aria-label="Abrir menu"
        >
          <Menu size={24} />
        </button>
        <h1 className="text-xl font-semibold">Monitoramento em tempo real</h1>
      </div>

      <div className="flex items-center gap-6">
        <AIAlertBell />
        <button
          onClick={handleLogout}
          className="flex items-center gap-2 text-sm bg-red-600 hover:bg-red-700 px-4 py-2 rounded-md"
        >
          <LogOut size={18} /> Sair
        </button>
      </div>
    </header>
  );
};

export default Header;
